import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api/api';

export const get_admin_orders = createAsyncThunk(
  'order/get_admin_orders',
  async ({ parPage, page, searchValue }, { rejectWithValue }) => {
    try {
      const { data } = await api.get(
        `/admin/orders?page=${page}&searchValue=${searchValue}&parPage=${parPage}`,
        { withCredentials: true }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: 'Server error' });
    }
  }
);

export const get_seller_orders = createAsyncThunk(
  'order/get_seller_orders',
  async ({ parPage, page, searchValue }, { rejectWithValue }) => {
    try {
      const { data } = await api.get(
        `/get-appointment?page=${page}&searchValue=${searchValue}&parPage=${parPage}`,
        { withCredentials: true }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: 'Server error' });
    }
  }
);

export const get_admin_order = createAsyncThunk(
  'order/get_admin_order',
  async (orderId, { rejectWithValue }) => {
    try {
      const { data } = await api.get(`/admin/order/${orderId}`, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: 'Server error' });
    }
  }
);

export const get_seller_order = createAsyncThunk(
  'order/get_seller_order',
  async (orderId, { rejectWithValue }) => {
    try {
      const { data } = await api.get(`/seller/order/${orderId}`, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: 'Server error' });
    }
  }
);

export const admin_order_status_update = createAsyncThunk(
  'order/admin_order_status_update',
  async ({ orderId, info }, { rejectWithValue }) => {
    try {
      const { data } = await api.put(`/admin/order-status/update/${orderId}`, info, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: 'Server error' });
    }
  }
);

export const seller_order_status_update = createAsyncThunk(
  'order/seller_order_status_update',
  async ({ orderId, info }, { rejectWithValue }) => {
    try {
      const { data } = await api.put(`/seller/order-status/update/${orderId}`, info, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: 'Server error' });
    }
  }
);


export const get_doctor_orders = createAsyncThunk(
  'order/get-doctorAppointment',
  async ({ parPage, page, searchValue }, { rejectWithValue }) => {
    try {
      const { data } = await api.get(
        `/get-doctorAppointment?page=${page}&searchValue=${searchValue}&parPage=${parPage}`,
        { withCredentials: true }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: 'Server error' });
    }
  }
);

export const packages_get = createAsyncThunk(
  'order/packages_get',
  async ({ parPage, page, searchValue }, { rejectWithValue }) => {
    try {
      const { data } = await api.get(
        `/packages_get?page=${page}&searchValue=${searchValue}&parPage=${parPage}`,
        { withCredentials: true }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: 'Server error' });
    }
  }
);

const orderSlice = createSlice({
  name: 'order',
  initialState: {
    successMessage: '',
    errorMessage: '',
    totalOrder: 0,
    Packages:[],
    totalPackage:0,
    order: null,
    myOrders: [],
    loading: false,
  },
  reducers: {
    messageClear: (state) => {
      state.errorMessage = '';
      state.successMessage = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(get_admin_orders.pending, (state) => {
        state.loading = true;
        state.errorMessage = '';
      })
      .addCase(get_admin_orders.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.myOrders = payload.orders || [];
        state.totalOrder = payload.totalOrder || 0;
      })
      .addCase(get_admin_orders.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.payload?.message || action.error.message;
      })

      // Seller Orders
      .addCase(get_seller_orders.pending, (state) => {
        state.loading = true;
        state.errorMessage = '';
      })
      .addCase(get_seller_orders.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.myOrders = payload.appointments || [];
        state.totalOrder = payload.totalappointment || 0;
      })
      .addCase(get_seller_orders.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.payload?.message || action.error.message;
      })

      // get_doctor_orders Orders
      .addCase(get_doctor_orders.pending, (state) => {
        state.loading = true;
        state.errorMessage = '';
      })
      .addCase(get_doctor_orders.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.doctorAppointments = payload.doctorAppointments || [];
        state.totaldoctorAppointment = payload.totaldoctorAppointment || 0;
      })
      .addCase(get_doctor_orders.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.payload?.message || action.error.message;
      })

      // Single Orders (Admin)
      .addCase(get_admin_order.pending, (state) => {
        state.loading = true;
        state.errorMessage = '';
      })
      .addCase(get_admin_order.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.order = payload.order || null;
      })
      .addCase(get_admin_order.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.payload?.message || action.error.message;
      })

      // Single Orders (Seller)
      .addCase(get_seller_order.pending, (state) => {
        state.loading = true;
        state.errorMessage = '';
      })
      .addCase(get_seller_order.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.order = payload.order || null;
      })
      .addCase(get_seller_order.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.payload?.message || action.error.message;
      })

      // Admin Order Status Update
      .addCase(admin_order_status_update.pending, (state) => {
        state.loading = true;
        state.errorMessage = '';
        state.successMessage = '';
      })
      .addCase(admin_order_status_update.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.successMessage = payload.message;
      })
      .addCase(admin_order_status_update.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.payload?.message || action.error.message;
      })

      // Seller Order Status Update
      .addCase(seller_order_status_update.pending, (state) => {
        state.loading = true;
        state.errorMessage = '';
        state.successMessage = '';
      })
      .addCase(seller_order_status_update.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.successMessage = payload.message;
      })
      .addCase(seller_order_status_update.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.payload?.message || action.error.message;
      })
    .addCase(packages_get.pending, (state) => {
      state.loading = true;
      state.errorMessage = '';
      state.successMessage = '';
    })
    .addCase(packages_get.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.successMessage = payload.message;
      state.Packages = payload.packages;
      state.totalPackage = payload.totalpackage;
    })
    .addCase(packages_get.rejected, (state, action) => {
      state.loading = false;
      state.errorMessage = action.payload?.message || action.error.message;
    });
  },
});

export const { messageClear } = orderSlice.actions;
export default orderSlice.reducer;
